import { makeStyles } from "@rbx/ui";

const useLoadPageStyles = makeStyles()(() => ({
  background: {
    marginTop: 68,
    marginBottom: 68,
  },
  button: {
    marginTop: 12,
  },
}));

export default useLoadPageStyles;
